import React from 'react';
import PropTypes from 'prop-types';
import Button, { LinkButton } from '@strava/ui/Button';
import { typography } from '@strava/ui-tokens/js';
import { useActivityPublicContext } from '../../ActivityPublicContext';

const CTA = ({ children, href, onClick, modalVariant, ...props }) => {
  const {
    openSignUpModal,
    showSignUpModal,
    registerUrl
  } = useActivityPublicContext();

  if (showSignUpModal) {
    return (
      <Button
        variant="primary"
        onClick={() => {
          onClick();
          openSignUpModal(modalVariant);
        }}
        style={{ fontWeight: typography.fontWeightDemi }}
        {...props}
      >
        {children}
      </Button>
    );
  }

  const url = href || registerUrl;

  return (
    <LinkButton
      variant="primary"
      href={
        url.includes('?')
          ? `${url}&reg_variant=${modalVariant}`
          : `${url}?reg_variant=${modalVariant}`
      }
      onClick={onClick}
      style={{ fontWeight: typography.fontWeightDemi }}
      {...props}
    >
      {children}
    </LinkButton>
  );
};

CTA.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string, // only used by control & variant-b
  modalVariant: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

CTA.defaultProps = {
  href: undefined
};

export default CTA;
